import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--document-upload" icon='document-upload'>{ children ? children : 'Document upload' }</Button>
}